import React, { useState, useContext, useEffect } from 'react';
import EventEmitter from 'eventemitter3';
import { MeasureOptions } from './MeasureOptions';
import { SpeedOptions } from './SpeedOptions';

interface OptionsComponentPorps {
  emitter: EventEmitter,
  currentOptions: number,
}

const OptionsComponent: React.FunctionComponent<OptionsComponentPorps> = (props) => {
  const { emitter, currentOptions } = props;

  const AvailableOptions = [ SpeedOptions, MeasureOptions ];
  const Options = AvailableOptions[currentOptions];

  return (<Options emitter={emitter} />)

};

export default OptionsComponent;
